import {CustomerMenuItem} from "../CustomerMenuItem";
import {buildDataSteps} from "../../../RiskProfiling/components/servicesV2/mock_customer_data";

export class CustomerMenuItemV2 extends CustomerMenuItem {
  async _getBankDetails() {
    // do nothing
  }

  setClearingAccountQuestionOptions() {
    // do nothing
  }

  validateBankAccountRequirements() {
    // do nothing
  }

  _buildSteps(customer){
    return buildDataSteps(customer);
  }

  async __setQuestionnaire(onboardingAnswers) {
    await super.__setQuestionnaire(onboardingAnswers);
    this.__is_new_design = true;
  }
}
